import React, { useState, Fragment, useEffect } from 'react';
import Popover from 'react-tiny-popover';
import PropTypes from 'prop-types';
import { isUndefined } from 'lodash';
import uuid from 'uuid/v4';

const InfoBox = React.forwardRef((props, ref) => {
  const {
    Positions,
    Align,
    InfoBoxButtonInner,
    updatePanels,
    containerClassName,
    Panels,
    gridType,
    stickyContent,
    childClassName,
    setCheckBlur,  // don't clear selections on Blur (specific to Autocode)

  } = props;
  const [boxOpen, setBoxOpen] = useState(false);
  const [boxPanels, setBoxPanels] = useState(Panels);

  // useEffect(() => {
  // }, []);

  // iterate through a collection of panels
  const renderInfoBoxPanels = () => {
    const ret = (
      <div className={childClassName} style={updatePanels ? {} : { paddingTop: '5px' }}>
        {boxPanels.map(x => (
          <Fragment key={uuid()}>{x}</Fragment>
        ))}
      </div>
    );
    const stickyItem = stickyContent ? (
      <div style={updatePanels ? {} : { paddingTop: '5px' }}>
        {stickyContent.map(x => (
          <Fragment key={uuid()}>{x}</Fragment>
        ))}
      </div>
    ) : null;
   return (
     <Fragment>
       {ret}
       {stickyItem}
     </Fragment>
   );
  };

  useEffect(() => {
    // specific to Autocode
    if (setCheckBlur && typeof(setCheckBlur) === 'function') setCheckBlur(!boxOpen);
  },[boxOpen]);

  const handleEllipsisClick = () => {
    setBoxOpen(!boxOpen);
    // calling buildInfoBox to update the panels array
    if (updatePanels) {
      const updatedPanels = updatePanels(gridType);
      setBoxPanels(updatedPanels);
    }
  };

  // https://github.com/alexkatz/react-tiny-popover
  const popoverProps = {
    isOpen: boxOpen,
    position: Positions,
    align: Align,
    padding: 2,
    transitionDuration: 0.01,
    // add small delay to onClickOutside to fix bug
    // where event in ToolPalette prevented this from finishing
    onClickOutside: () => setTimeout(() => setBoxOpen(false), 30),
    content: renderInfoBoxPanels(),
    containerClassName,
  };

  return (
    <Popover ref={ref} {...popoverProps}>
      <button
        type="button"
        onClick={handleEllipsisClick}
        className="ibox-ellipsis-btn"
        data-test="cacActionBtn"
      >
        {InfoBoxButtonInner}
      </button>
    </Popover>
  );
});

InfoBox.propTypes = {
  gridType: PropTypes.string,
  updatePanels: PropTypes.func,
  Panels: PropTypes.arrayOf(PropTypes.object),
  Positions: PropTypes.arrayOf(
    PropTypes.oneOf(['top', 'right', 'left', 'bottom'])
  ).isRequired,
  Align: PropTypes.oneOf(['start', 'center', 'end']).isRequired,
  InfoBoxButtonInner: PropTypes.element,
  containerClassName: PropTypes.string.isRequired,
  forwardRef: PropTypes.shape({}),
  stickyContent: PropTypes.arrayOf(PropTypes.object),
  childClassName: PropTypes.string,
  setCheckBlur: PropTypes.bool,
};

export const InfoBoxSpacer = props => {
  const { Height, boxClassName } = props;

  return <div style={{ height: Height }} className={boxClassName} />;
};

InfoBoxSpacer.propTypes = {
  boxClassName: PropTypes.string.isRequired,
  Height: PropTypes.string,
};

export const IBButton = props => {
  const { handleButtonClick, buttonText, btnClass } = props;

  const handleBtnClick = () => {
    handleButtonClick();
  };
  return (
    <button
      type="button"
      className={`ibButton ${!isUndefined(btnClass) && btnClass}`}
      onClick={handleBtnClick}
    >
      <div className="ibButtonText">{buttonText}</div>
    </button>
  );
};

IBButton.propTypes = {
  handleButtonClick: PropTypes.func.isRequired,
  buttonText: PropTypes.string.isRequired,
  btnClass: PropTypes.string,
  setCheckBlur: PropTypes.bool,
};

export default InfoBox;
